// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 18px 50px;
}

.menu__box {
  scroll-margin-top: 146px;
}

.menu__title {
  font-size: 40px;
  font-weight: 400;
  color: rgb(49,47,48);
  text-shadow: 10px 10px 30px rgb(122,148,90);
  margin: 18px;
}

.menu__categories {
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.menu__category-button {
  font-size: 18px;
  color: rgb(49,47,48);
  border: none;
  background-color: rgb(221, 219, 214);
  box-shadow: 0px 10px 30px rgba(180, 173, 161);
  border-radius: 5px;
  cursor: pointer;
}

.menu__category-button:hover {
  opacity: .8;
}

.products {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.product {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 18px;
  box-sizing: border-box;
  overflow: hidden;
}

.product__image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 5px;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.product__image:hover {
  transform: scale(1.1);
}

.product__name {
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  color: rgb(49,47,48);
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.4;
  margin: 10px 0;
}

.product__buttons {
  display: flex;
  width: 100%;
  flex-direction: row;
}

.product__button-minus{
  position: relative;
  width: 41px;
  height: 41px;
  border: 1px solid rgb(122,148,90);
  background-color: #f0f0f0;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 2px;
}

.product__button-minus::before {
  width: 60%;
  height: 4px;
}

.product__button-minus::after {
  display: none;
}

.product__button-minus:hover::before,
.product__button-minus:hover::after {
  background-color: #ff5722;
}

.product__button-add {
  width: 100%;
  font-size: 18px;
  color: rgb(208,205,193);
  border: none;
  background: rgb(122,148,90);
  border-radius: 5px;
  padding: 10px 0;
  cursor: pointer;
}

.product__button-add:hover {
  opacity: .8;
}

.product__button-remove {
  position: relative;
  width: 41px;
  height: 41px;
  border: 1px solid rgb(122,148,90);
  background-color: #f0f0f0;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
}

.product__button-remove::before,
.product__button-remove::after {
  content: '';
  position: absolute;
  width: 70%;
  height: 3px;
  background-color: rgb(122,148,90);
  transition: background-color 0.3s ease;
}

.product__button-remove::before {
  transform: rotate(45deg);
}

.product__button-remove::after {
  transform: rotate(-45deg);
}

.product__button-remove:hover::before,
.product__button-remove:hover::after {
  background-color: #ff5722;
}

button::before,
button::after {
  content: '';
  position: absolute;
  background-color: rgb(122,148,90);
  transition: background-color 0.3s ease;
}

@media screen and (max-width: 1200px) {
  .menu {
    padding-left: 10px;
    padding-right: 10px;
  }

  .menu__title {
    margin: 10px;
  }

  .menu__categories {
    gap: 10px;
    margin-bottom: 10px;
  }

  .products {
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  .product {
    margin-bottom: 10px;
  }

  .product__name {
    margin: 10px;
  }
}

@media screen and (max-width: 910px) {
  .products {
    grid-template-columns: repeat(3, 1fr);
  }

  .menu__title {
    font-size: 30px;
  }
}

@media screen and (max-width: 700px) {
  .menu {
    padding-left: 5px;
    padding-right: 5px;
  }

  .menu__title {
    margin: 5px;
  }

  .menu__categories {
    gap: 5px;
  }

  .products {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
}

@media screen and (max-width: 400px) {
  .products {
    grid-template-columns: repeat(1, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Products.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".menu {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  padding: 0px 18px 50px;\r\n}\r\n\r\n.menu__box {\r\n  scroll-margin-top: 146px;\r\n}\r\n\r\n.menu__title {\r\n  font-size: 40px;\r\n  font-weight: 400;\r\n  color: rgb(49,47,48);\r\n  text-shadow: 10px 10px 30px rgb(122,148,90);\r\n  margin: 18px;\r\n}\r\n\r\n.menu__categories {\r\n  display: flex;\r\n  gap: 18px;\r\n  margin-bottom: 18px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.menu__category-button {\r\n  font-size: 18px;\r\n  color: rgb(49,47,48);\r\n  border: none;\r\n  background-color: rgb(221, 219, 214);\r\n  box-shadow: 0px 10px 30px rgba(180, 173, 161);\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu__category-button:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.products {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n.product {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  border-radius: 5px;\r\n  margin-bottom: 18px;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n\r\n.product__image {\r\n  width: 100%;\r\n  height: 200px;\r\n  object-fit: cover;\r\n  border-radius: 5px;\r\n  transition: transform 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.product__image:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.product__name {\r\n  height: 50px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: rgb(49,47,48);\r\n  white-space: normal;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  word-wrap: break-word;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  line-height: 1.4;\r\n  margin: 10px 0;\r\n}\r\n\r\n.product__buttons {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: row;\r\n}\r\n\r\n.product__button-minus{\r\n  position: relative;\r\n  width: 41px;\r\n  height: 41px;\r\n  border: 1px solid rgb(122,148,90);\r\n  background-color: #f0f0f0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-right: 2px;\r\n}\r\n\r\n.product__button-minus::before {\r\n  width: 60%;\r\n  height: 4px;\r\n}\r\n\r\n.product__button-minus::after {\r\n  display: none;\r\n}\r\n\r\n.product__button-minus:hover::before,\r\n.product__button-minus:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n\r\n.product__button-add {\r\n  width: 100%;\r\n  font-size: 18px;\r\n  color: rgb(208,205,193);\r\n  border: none;\r\n  background: rgb(122,148,90);\r\n  border-radius: 5px;\r\n  padding: 10px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.product__button-add:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.product__button-remove {\r\n  position: relative;\r\n  width: 41px;\r\n  height: 41px;\r\n  border: 1px solid rgb(122,148,90);\r\n  background-color: #f0f0f0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-left: 2px;\r\n}\r\n\r\n.product__button-remove::before,\r\n.product__button-remove::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 70%;\r\n  height: 3px;\r\n  background-color: rgb(122,148,90);\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.product__button-remove::before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.product__button-remove::after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.product__button-remove:hover::before,\r\n.product__button-remove:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n\r\nbutton::before,\r\nbutton::after {\r\n  content: '';\r\n  position: absolute;\r\n  background-color: rgb(122,148,90);\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .menu {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .menu__title {\r\n    margin: 10px;\r\n  }\r\n\r\n  .menu__categories {\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .products {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 10px;\r\n  }\r\n\r\n  .product {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .product__name {\r\n    margin: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .products {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n\r\n  .menu__title {\r\n    font-size: 30px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n  .menu {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n\r\n  .menu__title {\r\n    margin: 5px;\r\n  }\r\n\r\n  .menu__categories {\r\n    gap: 5px;\r\n  }\r\n\r\n  .products {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 5px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 400px) {\r\n  .products {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
